export default "__VITE_ASSET__kKw1Ntg___"